import type { ISerialize } from '@/objects/ISerialize';

export class EventInfoSelectLine implements ISerialize {
    public text: string;

    public value: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { text?: string | null; value?: number }) {
        this.text = values.text ?? '';

        this.value = values.value ?? 0;
    }

    public serialize(): string {
        return '{' + `"text": ${JSON.stringify(this.text)}` + ',' + `"value": ${JSON.stringify(this.value)}` + '}';
    }

    /**
     * Creates an instance of EventInfoSelectLine from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { text?: string | null; value?: number }): EventInfoSelectLine {
        return new EventInfoSelectLine(values);
    }

    public static _FromServerJson(json: any): EventInfoSelectLine {
        return new EventInfoSelectLine({ text: json.text ?? '', value: json.value });
    }

    /**
     * Creates an instance of EventInfoSelectLine from another instance of EventInfoSelectLine.
     * @param other The EventInfoSelectLine you want to clone
     * @returns A cloned EventInfoSelectLine
     */
    public static FromOther(other: EventInfoSelectLine): EventInfoSelectLine {
        return EventInfoSelectLine._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return EventInfoSelectLine.FromOther(this);
    }

    static NAME_OF_CLASS = 'EventInfoSelectLine';
}
